import { seoPack } from "./seo-content";
import type { Locale } from "@/i18n/locales";
import type { HotComparison, CompareRow } from "./hot-compare";

/** Localised copy only. Slugs, brands, sources and keywords stay English-defined. */
export type HotCompareTranslation = {
  h1?: string;
  title?: string;
  description?: string;
  intro?: string;
  summary?: string[];
  rows?: CompareRow[];
  faq?: [string, string][];
};

export type HotCompareLocalePack = Partial<Record<string, HotCompareTranslation>>;


export type HotCompareContent = Pick<
  HotComparison,
  "h1" | "title" | "description" | "intro" | "summary" | "rows" | "faq"
>;

export function getHotCompareContent(
  locale: Locale,
  cmp: HotComparison,
): HotCompareContent {
  const t = locale === "en" ? undefined : seoPack(locale)?.hotCompare?.[cmp.slug];
  return {
    h1: t?.h1 ?? cmp.h1,
    title: t?.title ?? cmp.title,
    description: t?.description ?? cmp.description,
    intro: t?.intro ?? cmp.intro,
    summary: t?.summary?.length === cmp.summary.length ? t.summary! : cmp.summary,
    rows: t?.rows?.length === cmp.rows.length ? t.rows! : cmp.rows,
    faq: t?.faq?.length === cmp.faq.length ? t.faq! : cmp.faq,
  };
}
